import { requiredText } from 'shared/libs/text/requered-text'
import {
  inputClassname,
  placeholderClassname,
  wrapperClassName,
} from 'shared/model/classnames'

import { RenderFormItem } from 'shared/ui/Form/FormItems'

const rules = [{ required: true, message: requiredText }]
export const addKeyAccessFormFields: RenderFormItem[] = [
  // {
  //   type: 'customTextField',
  //   itemProps: {
  //     className: inputClassname,
  //     wrapperClassname: wrapperClassName,
  //     placeholderClassname: placeholderClassname,
  //     placeholder: 'Логин',
  //   },
  //   // formItemProps: {
  //   //   name: 'login',
  //   //   rules: rules,
  //   // },
  // },
  {
    type: 'customPasswordField',
    itemProps: {
      className: inputClassname,
      wrapperClassname: wrapperClassName,
      placeholderClassname: placeholderClassname,
      placeholder: 'Пароль',
    },
    formItemProps: {
      name: 'password',
      rules: rules,
    },
  },
  {
    type: 'customPasswordField',
    itemProps: {
      className: inputClassname,
      wrapperClassname: wrapperClassName,
      placeholderClassname: placeholderClassname,
      placeholder: 'Повторный ввод пароля',
    },
    formItemProps: {
      name: 'password_verification',
      rules: rules,
    },
  },
]
